import { Common } from '../common';
import {
  InsuranceInformation,
  InsuranceInformationWithDetails,
} from '../models/patient/insuranceInformation';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllWithDetails(
    previsitFormSetId: string,
  ): Promise<InsuranceInformationWithDetails[]> {
    const url = this.common.constructPath(
      '/patient-previsit/patient-insurance-information',
      { previsitFormSetId },
    );
    const { patientInsuranceInformations } = await this.common.getJSON(url);
    return patientInsuranceInformations;
  }

  async update(args: {
    insuranceInformationId: string;
    values: Partial<InsuranceInformation>;
    encounterId: string;
  }): Promise<InsuranceInformation> {
    const { insuranceInformationId, values, encounterId } = args;
    const url = this.common.constructPath(
      `/patient-previsit/patient-insurance-information/${insuranceInformationId}`,
    );
    return await this.common.patchJSON(url, { ...values, encounterId });
  }

  async remove(args: {
    insuranceInformationId: string;
    encounterId: string;
  }): Promise<{ success: boolean }> {
    const { insuranceInformationId, encounterId } = args;
    const url = this.common.constructPath(
      `/patient-previsit/patient-insurance-information/${insuranceInformationId}`,
      { encounterId },
    );
    return this.common.deleteJSON(url);
  }

  async recover(args: {
    insuranceInformationId: string;
    encounterId: string;
  }): Promise<{ success: boolean }> {
    const { insuranceInformationId, encounterId } = args;
    const url = this.common.constructPath(
      `/patient-previsit/patient-insurance-information/${insuranceInformationId}`,
    );
    return this.common.patchJSON(url, { deletedTimestamp: null, encounterId });
  }

  async plan(insuranceInformationId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(
      `/patient-previsit/patient-insurance-information/${insuranceInformationId}/plan`,
    );
    return await this.common.postJSON(url, {});
  }
}
